if (!customElements.get('clinicians-choice')) {
 customElements.define('clinicians-choice', class extends HTMLElement {
  connectedCallback() {
   if(this.controller) return;
   this.controller=new AbortController();const options={signal:this.controller.signal};
   const placeholder = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20100%20100%22%3E%3Crect%20width%3D%22100%22%20height%3D%22100%22%20rx%3D%2250%22%20fill%3D%22%23eeeeee%22%2F%3E%3Ccircle%20cx%3D%2250%22%20cy%3D%2236%22%20r%3D%2218%22%20fill%3D%22%23b5b5b5%22%2F%3E%3Cpath%20d%3D%22M18%2092c0-24%2013-36%2032-36s32%2012%2032%2036%22%20fill%3D%22%23b5b5b5%22%2F%3E%3C%2Fsvg%3E";
   this.querySelectorAll('img').forEach(img => {
    const fallback = () => {
     if (img.getAttribute('src') === placeholder) return;
     img.removeAttribute('srcset');
     img.src = placeholder;
    };
    img.addEventListener('error', fallback, options);
    if (!(img.getAttribute('src') || '').trim() || (img.complete && img.naturalWidth === 0)) fallback();
   });
   const dialog=this.querySelector('dialog'),frame=this.querySelector('iframe'),trigger=this.querySelector('[data-open]');
   const restore=()=>{if(this.locked){document.documentElement.style.overflow=this.previousOverflow;this.locked=false;}trigger.focus();};
   trigger.addEventListener('click',()=>{if(!frame.hasAttribute('srcdoc') || frame.getAttribute('srcdoc') === 'null') {
    let documentHTML = frame.getAttribute('data-modal-document');
    const template = this.querySelector('template');
    if (!documentHTML && template) {
     documentHTML = template.content.childElementCount ? template.innerHTML : template.content.textContent;
    }
    if (!documentHTML || !/<(?:html|div|style|details)[\s>]/i.test(documentHTML)) {
     console.error('Clinicians Choice: missing modal HTML. Update clinicians-choice.liquid and clinicians-modal.liquid together.');
     return;
    }
    frame.srcdoc = documentHTML;
   }this.previousOverflow=document.documentElement.style.overflow;this.locked=true;document.documentElement.style.overflow='hidden';dialog.showModal();frame.focus();},options);
   dialog.addEventListener('close',restore,options);
   dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}},options);
   window.addEventListener('message',e=>{if(e.source===frame.contentWindow&&e.data==='clinicians-close')dialog.close();},options);
  }
  disconnectedCallback(){if(this.locked){document.documentElement.style.overflow=this.previousOverflow;this.locked=false;}this.controller?.abort();this.controller=null;}
 });
}
